// 亚运会顶部菜单

module.exports = {
  sportType: 'compreSportsMeet',
  menuData: [
    {
      name: 'webMenu',
      arr: [
        // {
        //   name: '赛程',
        //   key: 'schedule',
        //   routeName: 'CSMeetScheduleIndex_ASG',
        //   act: true,
        // },
        {
          name: '赛程',
          key: 'schedule',
          routeName: 'CSMeetScheduleIndex_ASG',
          act: true,
          child: [
            {
              name: '常规赛程',
              key: 'regularSchedule',
              routeName: 'CSMeetRegularScheduleIndex_ASG',
              act: false,
            },
            {
              name: '运动员赛程',
              key: 'playersSchedule',
              act: false,
              routeName: 'CSMeetEventPlayersScheduleIndex_ASG',
            },
            {
              name: '项目阶段',
              key: 'eventPhase',
              act: false,
              routeName: 'CSMeetEventPhaseIndex_ASG',
            },
          ],
        },
        {
          name: '项目',
          key: 'bigSports',
          routeName: 'CSMeetBigSportsIndex_ASG',
          act: false,
        },
        {
          name: '奖牌',
          key: 'medal',
          routeName: 'CSMeetMedalIndex_ASG',
          act: false,
          child: [
            {
              name: '奖牌榜',
              key: 'medalTally',
              routeName: 'CSMeetMedalTallyIndex_ASG',
              act: false,
            },
            {
              name: '奖牌明细',
              key: 'medalDetailList',
              act: false,
              routeName: 'CSMeetMedalDetailListIndex_ASG',
            },
          ],
        },
        {
          name: '代表团',
          key: 'delegation',
          routeName: 'CSMeetDelegationIndex_ASG',
          act: false,
        },
        {
          name: '运动员',
          key: 'player',
          routeName: 'CSMeetPlayerIndex_ASG',
          act: false,
        },
        {
          name: '纪录',
          key: 'record',
          routeName: 'CSMeetRecordIndex_ASG',
          act: false,
        },
        {
          name: '场馆',
          key: 'venue',
          routeName: 'CSMeetVenueIndex_ASG',
          act: false,
        },
      ],
    },
    {
      name: 'openMenu',
      arr: [
        {
          name: '节目单',
          key: 'programList',
          routeName: 'CSMeetProgramListIndex_ASG',
          act: false,
          isOpenWeb: true,
        },
        {
          name: '播出单',
          key: 'broadcastList',
          routeName: 'CSMeetBroadcastListIndex_ASG',
          act: false,
          isOpenWeb: true,
        },
        {
          name: '数据包装',
          key: 'dataPackagList',
          routeName: 'CSMeetDataPackagListIndex_ASG',
          act: false,
          isOpenWeb: true,
        },
      ],
    },
  ],
}
